import { render } from "./CourseMemberContent.vue?vue&type=template&id=3dd5441a&scoped=true"
import script from "./CourseMemberContent.vue?vue&type=script&lang=js"
export * from "./CourseMemberContent.vue?vue&type=script&lang=js"

import "./CourseMemberContent.vue?vue&type=style&index=0&id=3dd5441a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd5441a"]])

export default __exports__